package com.evoapps.evoshift.ui.courses

import com.evoapps.evoshift.domain.model.CourseKind
import com.evoapps.evoshift.domain.model.CoursePageKind
import com.evoapps.evoshift.domain.model.OhsWorkerGroup
import com.evoapps.evoshift.domain.model.PresentationLinkProblem
import com.evoapps.evoshift.domain.model.PresentationSource
import com.evoapps.evoshift.domain.model.TrainingState
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.course_kind_general
import evoshift.composeapp.generated.resources.course_kind_general_hint
import evoshift.composeapp.generated.resources.course_kind_ohs_general
import evoshift.composeapp.generated.resources.course_kind_ohs_general_hint
import evoshift.composeapp.generated.resources.course_kind_ohs_periodic
import evoshift.composeapp.generated.resources.course_kind_ohs_periodic_hint
import evoshift.composeapp.generated.resources.course_page_image
import evoshift.composeapp.generated.resources.course_page_presentation
import evoshift.composeapp.generated.resources.course_presentation_link_not_https
import evoshift.composeapp.generated.resources.course_presentation_link_not_presentation
import evoshift.composeapp.generated.resources.course_presentation_link_unsupported
import evoshift.composeapp.generated.resources.presentation_source_google
import evoshift.composeapp.generated.resources.presentation_source_office
import evoshift.composeapp.generated.resources.presentation_source_prezi
import evoshift.composeapp.generated.resources.presentation_source_upload
import evoshift.composeapp.generated.resources.course_page_text
import evoshift.composeapp.generated.resources.course_page_video
import evoshift.composeapp.generated.resources.ohs_group_admin_office
import evoshift.composeapp.generated.resources.ohs_group_blue_collar
import evoshift.composeapp.generated.resources.ohs_group_managers
import evoshift.composeapp.generated.resources.ohs_group_other
import evoshift.composeapp.generated.resources.training_state_done
import evoshift.composeapp.generated.resources.training_state_overdue
import evoshift.composeapp.generated.resources.training_state_pending
import org.jetbrains.compose.resources.StringResource

/* SH-126: the labels of the training enums (screens and robots resolve them). */

fun CourseKind.label(): StringResource = when (this) {
    CourseKind.GENERAL -> Res.string.course_kind_general
    CourseKind.OHS_GENERAL -> Res.string.course_kind_ohs_general
    CourseKind.OHS_PERIODIC -> Res.string.course_kind_ohs_periodic
}

fun CourseKind.hint(): StringResource = when (this) {
    CourseKind.GENERAL -> Res.string.course_kind_general_hint
    CourseKind.OHS_GENERAL -> Res.string.course_kind_ohs_general_hint
    CourseKind.OHS_PERIODIC -> Res.string.course_kind_ohs_periodic_hint
}

fun CoursePageKind.label(): StringResource = when (this) {
    CoursePageKind.TEXT -> Res.string.course_page_text
    CoursePageKind.IMAGE -> Res.string.course_page_image
    CoursePageKind.VIDEO_LINK -> Res.string.course_page_video
    CoursePageKind.PRESENTATION -> Res.string.course_page_presentation
}

/** SH-211: where a presentation comes from. */
fun PresentationSource.label(): StringResource = when (this) {
    PresentationSource.GOOGLE_SLIDES -> Res.string.presentation_source_google
    PresentationSource.PREZI -> Res.string.presentation_source_prezi
    PresentationSource.OFFICE -> Res.string.presentation_source_office
    PresentationSource.UPLOAD -> Res.string.presentation_source_upload
}

/** SH-211: why a presentation link is not accepted. */
fun PresentationLinkProblem.label(): StringResource = when (this) {
    PresentationLinkProblem.NOT_HTTPS -> Res.string.course_presentation_link_not_https
    PresentationLinkProblem.UNSUPPORTED_SITE -> Res.string.course_presentation_link_unsupported
    PresentationLinkProblem.NOT_A_PRESENTATION -> Res.string.course_presentation_link_not_presentation
}

fun OhsWorkerGroup.label(): StringResource = when (this) {
    OhsWorkerGroup.BLUE_COLLAR -> Res.string.ohs_group_blue_collar
    OhsWorkerGroup.MANAGERS -> Res.string.ohs_group_managers
    OhsWorkerGroup.ADMIN_OFFICE -> Res.string.ohs_group_admin_office
    OhsWorkerGroup.OTHER -> Res.string.ohs_group_other
}

fun TrainingState.label(): StringResource = when (this) {
    TrainingState.DONE -> Res.string.training_state_done
    TrainingState.PENDING -> Res.string.training_state_pending
    TrainingState.OVERDUE -> Res.string.training_state_overdue
}
